module.exports = __webpack_public_path__ + "img/honor_bg.jpg";